// extracted by mini-css-extract-plugin
export var container = "echoVsTelemed-module--container--c7961";
export var content = "echoVsTelemed-module--content--d4b40";
export var heading = "echoVsTelemed-module--heading--f6133";
export var image = "echoVsTelemed-module--image--5a1e8";